/**
 * Product Brand Credibility — scroll reveal fallback when air-reveal is unavailable.
 */
(function () {
  if (document.documentElement.classList.contains('air-reveal-ready')) return;

  if (typeof window.IntersectionObserver === 'undefined') return;

  var targets = document.querySelectorAll('.pbc__header, .pbc__awards, .pbc__certs, .pbc__stats');
  if (!targets.length) return;

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) return;

  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    { threshold: 0.07 }
  );

  targets.forEach(function (el) {
    obs.observe(el);
  });
})();
